import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const NotificationsPage = lazy(() =>
  import('./pages/NotificationsPage').then((module) => ({ default: module.NotificationsPage })),
);

// No permission prop: every authenticated user has an inbox of their own.
// Guarding it with an RBAC permission would lock the bell for a role that is
// otherwise allowed to log in.
export const notificationsRoutes: RouteObject[] = [
  {
    path: 'notificaciones',
    element: createElement(ProtectedRoute),
    children: [{ index: true, element: createElement(NotificationsPage) }],
  },
];
